import React from "react";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import { style } from "./style";

import GenericCardHeader from "@/components/GenericCardHeader";
import GetImages from "@/components/GetImages";
import Button from "@/components/Button";
import TruncatedText from "@/components/TruncatedText";

import {
  IAllOrderTypeEnums,
  IOrderStatus,
} from "@/models/ApiRequestResponse/patient";
import { IButtonVariant } from "@/models/button";

import {
  calculateDayFromTargetDate,
  openClinicMapLocation,
  transformDateToDDMMYYYY,
} from "@/utils";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { config, setIsShowUniversalSearch } from "@/store/slices/config";

interface IProps {
  status: IOrderStatus;
  admission_date?: string;
  discharged_date?: any;
  name: string;
  photo?: string;
  patientName?: string;
  age?: number;
  gender?: string;
  icu_ward_phone_number?: string;
  latitude?: number;
  longitude?: number;
  address?: string;
  doctorName?: string;
  doctor_id?: string;
  member_id?: string;
}
const AdmitOrDischargedPatient: React.FC<IProps> = (props) => {
  const {
    status,
    admission_date,
    name,
    photo,
    discharged_date,
    patientName,
    age,
    gender,
    icu_ward_phone_number,
    address,
    latitude,
    longitude,
    doctorName,
    doctor_id,
    member_id,
  } = props;

  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const { isShowUniversalSearch } = useAppSelector(config);

  const ipDashboardChatRedirectHandler = () => {
    navigate("/chat", {
      state: {
        channelId: `ip_${doctor_id}_${member_id}`,
      },
    });
    if (isShowUniversalSearch) {
      dispatch(setIsShowUniversalSearch(false));
    }
  };
  return (
    <Grid item sx={style.cardContainer}>
      <GenericCardHeader
        orderStatus={status}
        doctorId={""}
        name={name}
        bio={`
     ${
       status === IOrderStatus.ADMIT
         ? `Admitted on ${transformDateToDDMMYYYY(
             admission_date
           )} (${calculateDayFromTargetDate(admission_date)})`
         : `${transformDateToDDMMYYYY(
             admission_date
           )} - ${transformDateToDDMMYYYY(discharged_date)}`
     }`}
        image={photo}
        orderType={IAllOrderTypeEnums.HOSPITAL}
      />
      <Grid item sx={style.patientDetail}>
        <Typography component={"p"} sx={style.detail}>
          <GetImages name={"DoctorSearchIcon"} width="20" height="20" />
          {doctorName}
        </Typography>
        <Typography component={"p"} sx={style.detail}>
          <GetImages name={"SmileOrderIcon"} width="18" height="16" />
          {patientName}, {gender}, {age}
        </Typography>
        <Typography
          component={"p"}
          sx={{
            ...style.detail,
            ...style.hideOrShowBlock,
          }}
        >
          <GetImages name={"TelePhoneIcon"} width="18" height="16" />
          <FormattedMessage
            id={
              status === IOrderStatus.ADMIT ? "call_icu_ward" : "follow_up_call"
            }
            defaultMessage={
              status === IOrderStatus.ADMIT
                ? "Call ICU/Ward"
                : "For Follow up call"
            }
          />{" "}
          - {icu_ward_phone_number}
        </Typography>
        <Grid item sx={style.clinicInfo}>
          <TruncatedText
            text={address}
            muiStyles={style.detail}
            maxLength={30}
            icon={
              <GetImages name={"HospitalLocationIcon"} width="18" height="16" />
            }
          />
          {status !== IOrderStatus.PENDING && (
            <Grid
              item
              sx={style.clinicLocation}
              onClick={() =>
                openClinicMapLocation(latitude ?? 0, longitude ?? 0)
              }
            >
              <GetImages name="HospitalLocationIcon" width="18" height="16" />
              <Typography component={"p"} sx={style.mapText}>
                <FormattedMessage id="maps" defaultMessage="Maps" />
              </Typography>
            </Grid>
          )}
        </Grid>
        <Grid item sx={style.buttonContainer}>
          <Grid item sx={style.callButton}>
            <Button
              variant={IButtonVariant.WHITE}
              btnTrigger={() =>
                (window.location.href = `tel:${icu_ward_phone_number}`)
              }
            >
              <GetImages name={"TelePhoneIcon"} width="24" height="16" />
              <FormattedMessage
                id={
                  status === IOrderStatus.ADMIT
                    ? "call_icu_ward"
                    : "follow_up_call"
                }
                defaultMessage={
                  status === IOrderStatus.ADMIT
                    ? "Call ICU/Ward"
                    : "For Follow Up"
                }
              />
            </Button>
          </Grid>
          <Button
            variant={IButtonVariant.ORANGE}
            btnTrigger={ipDashboardChatRedirectHandler}
          >
            <GetImages name={"IpDashboardMessageIcon"} width="28" height="20" />
            <FormattedMessage id="get_update" defaultMessage="Get Update" />
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default AdmitOrDischargedPatient;
